import { userEstimateList } from '@/api/asset/pool/read';
import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { UserEstimateRewardTableColumns } from '../pools/table/ColumnsData';
import { fontWeight } from '@/theme';
import { Tables } from '../pools/table/Tables';
import { now } from '@/lib/dayjs';
import { ResUserEstimateList } from '@/types';

type EstimateList = {
  [key: string]: ResUserEstimateList[];
};
export default function PoolRewardDetailList({ poolId }: { poolId: string }) {
  const [list, setList] = useState<EstimateList>();
  useEffect(() => {
    (async () => {
      const re = await userEstimateList(poolId);
      const res: EstimateList = Object.keys(re.data).reduce((acc: EstimateList, key: string) => {
        acc[key] = re.data[key].map((item: ResUserEstimateList) => ({
          ...item,
          index: item.estimate_id,
        }));
        return acc;
      }, {});
      setList(res);
    })();

    return () => {};
  }, [poolId]);

  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flex: 1,
        flexDirection: 'column',
        gap: { xs: '16px', sm: '0px' },
      }}
    >
      <Typography variant="h5" fontWeight={fontWeight.Bold} textAlign="left">
        사용자 예상 리워드
      </Typography>
      <Box mb={2} />

      {list &&
        Object.keys(list).map((key: string, index: number) => {
          const firstItem = list[key][0]; // 각 그룹의 첫 번째 아이템을 가져옴
          const regDt = firstItem?.reg_dt || 'No Date'; // 첫 번째 아이템의 reg_dt 값을 가져오거나 'No Date' 사용

          console.log(`Key: ${key}`, 'Data:', list[key], 'Date:', list[key][0].reg_dt);

          return (
            <div key={key}>
              <Typography variant="h6" fontWeight="medium" textAlign="left">
                {`key: ${key}, date:${regDt}`} {/* reg_dt 값을 제목으로 표시 */}
              </Typography>
              <Tables
                list={list[key]} // 해당 그룹의 전체 데이터를 Tables 컴포넌트로 전달
                columns={UserEstimateRewardTableColumns} // 열 정의
                csvName={`${regDt} - ${new Date().toISOString()}`} // CSV 파일 이름에 현재 날짜 추가
              />
              <Box mb={5} />
            </div>
          );
        })}
    </Box>
  );
}
